import type { ListarParametrosQuery, NovoParametroDto, ParametroEmpresaResponse } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

export function useParametros(q: Partial<ListarParametrosQuery> = {}) {
  return useConsulta<ParametroEmpresaResponse[]>(['parametros-empresa'], '/parametros-empresa', { query: q });
}

export function useParametroVigente(data: string | undefined) {
  return useConsulta<ParametroEmpresaResponse>(['parametros-empresa', 'vigente', data], '/parametros-empresa/vigente', {
    query: { data },
    ativo: !!data,
  });
}

export function useNovoParametro() {
  return useMutacao<ParametroEmpresaResponse, NovoParametroDto>({
    metodo: 'POST', caminho: () => '/parametros-empresa', corpo: (v) => v, invalidar: [['parametros-empresa']],
  });
}
